var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['alert', `alert-${_vm.type}`, _vm.dismissClass]},[(_vm.dismissable)?_c('button',{staticClass:"close",attrs:{"type":"button"}},[_c('i',{staticClass:"fas fa-times"})]):_vm._e(),_vm._v(" "),(_vm.title)?_c('h5',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }